const views = {
  REGIONAL_CLUSTER: 'regional-cluster',
  EMPLOYMENT: 'employment',
  OCCUPATIONAL: 'occupational',
  HOME: 'home',
  ABOUT: 'about',
  DATA: 'data'
}
module.exports = {
  VIEWS: views,
  FILE_KEYS: {
    CLUSTERS_REFERENCE: 'clusters',
    NACE_REFERENCE: 'nace',
    ISCO_REFERENCE: 'isco',
    NUTS3_SHAPES: 'nuts3',
    COUNTRIES_REFERENCE: 'countries',
    URBAN_REFERENCE: 'urbans',
    EMPLOYMENT_DATA: 'employment_data',
    OCCUPATIONAL_DATA: 'occupational_data',
    OCCUPATIONAL_TOP10_CHANGES: 'occupational_changes',
    OCCUPATIONAL_TOP10_SHARE: 'occupational_shares',
    OCCUPATIONAL_EU: 'occupational_eu',
    OCCUPATIONAL_CLUSTERS: 'occupational_clusters',
    METRO_STATS: 'metro_stats',
    NUTS3_PRESENT: 'nuts3_present',
    NUTS3_FUTURE: 'nuts3_future',
    CLUSTERS_AVG_PRESENT: 'clusters_avg',
    NUTS3_TOP_OCCUPATIONS_FUTURE: 'nuts3_top_occupations_future',
  },
  MAPBOX_TOKEN: "pk.eyJ1IjoicGFsYW1hZ28iLCJhIjoiY2s2Y2xicmNnMGxvNjNsczB0bnN5cnhzYSJ9.yIahM0bJCM7kAjuKt061Og",
  NAV:{
    main: [
      {
        name: "Introduction",
        slug: "home",
        icon: false,
        type: "view",
        link: `/page/${views.HOME}`
      },
      {
        name: "EU-wide perspective",
        slug: views.EMPLOYMENT,
        icon: false,
        type: "view",
        link: `/map/${views.EMPLOYMENT}/intro`,
        filter: false,
        isMap: true,
        largeName: "EU-wide perspectives"
      },
      {
        name: "Labor Markets",
        slug: views.REGIONAL_CLUSTER,
        icon: false,
        type: "view",
        link: `/map/${views.REGIONAL_CLUSTER}/intro`,
        filter: false,
        isMap: true,
        largeName: "Labor market clusters"
      },
      {
        name: "Occupations",
        slug: views.OCCUPATIONAL,
        icon: false,
        type: "view",
        link: `/map/${views.OCCUPATIONAL}/intro`,
        filter: false,
        isMap: true,
        largeName: "Specific occupations"
      },
      {
        name: "About",
        slug: views.ABOUT,
        icon: false,
        type: "view",
        link: `/page/${views.ABOUT}`
      }/*,
      {
        name: "Read Report",
        slug: 'repot',
        icon: false,
        type: "external",
        link: "https://www.mckinsey.com/featured-insights/future-of-work/the-future-of-work-in-europe"
      }*/
    ],
    subnav: [
      {
        name: "Description",
        slug: "intro"
      },
      {
        name: "Today",
        slug: "today"
      },
      {
        name: "Outlook 2030",
        slug: "outlook"
      }
    ],
  },
  IGNORE_SHAPES_IDS:[
    "FRY30",
    "FRY20",
    "FRY10",
    "FRY40",
    "FRY50"
  ],
  FEATURED_REGIONS: [
    "FR101",
    "ITI43",
    "DE300"
  ],
  NAV_FIXED_WHERE_SCROLL: 120,
  EMPLOYMENT_FIELDS: {
    today_job_growth: "net_job_growth_2011_18_in_share",
    future_job_growth: "net_job_growth_2018_30_in_share",
    today_employment_rate: "employment_rate_2018",
    future_employment_rate: "employment_rate_2030_in_share"
  },
  OCCUPATIONAL_FIELDS: {
    today_absolute: "employment_absolute_2018_thousands",
    future_absolute: "employment_absolute_2030_thousands",
    today_relative: "employment_share_of_region_2018_percent",
    future_relative: "employment_share_of_region_2030_percent",
    delta: "jobs_change_18_30_percent"
  },
  EMPLOYMENT_NAMES: {
    today_job_growth: "Job growth 2011-18",
    future_job_growth: "Job growth 2018-30",
    today_employment_rate: "Employment rate 2018",
    future_employment_rate: "Employment rate 2030"
  },
  FUTURE_DISCLAIMER: "Note: Projections for the EU-27 countries plus the United Kingdom and Switzerland; Analysis of long-term labor market trends and impact of automation was conducted before COVID-19 pandemic. Displacement due to automation and net job growth figures were estimated based on midpoint automation scenario. For discussion of the assumptions, sensitivities, and limitations of our automation scenarios, see A future that works: Automation, employment, and productivity, McKinsey Global Institute, January 2017."
}
